module.exports = __webpack_public_path__ + "static/media/logo-nav.18b1f5c1.svg";